export const face = "/images/face.jpg";
export const info = {
  name: "Stephen BOLIVAR",
  title: "Créateur de solutions numériques",
  phone: "+590690861909",
  prettyPhone: "+590 690 86 19 09",
  mail: "bolispam@outlook.com",
};
